export default "__VITE_ASSET__DuKW59VS__"